import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

const CopyField = ({ label, value, testid }) => {
  const [copied, setCopied] = useState(false);
  const onCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    toast.success(`${label} copied`);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="flex items-center justify-between bg-orange-50 px-3 py-2 rounded-md text-sm">
      <div>
        <span className="text-gray-500 mr-2">{label}:</span>
        <span className="font-mono font-semibold text-gray-800">{value}</span>
      </div>
      <button
        type="button"
        onClick={onCopy}
        data-testid={testid}
        className="text-orange-600 hover:text-orange-700 p-1"
        aria-label={`Copy ${label}`}
      >
        {copied ? <Check size={16} /> : <Copy size={16} />}
      </button>
    </div>
  );
};

export const UpiBlock = ({ payment, total }) => (
  <div className="border border-orange-200 rounded-lg p-4 bg-gradient-to-br from-orange-50 to-yellow-50" data-testid="upi-block">
    <p className="text-sm text-gray-700 mb-3">
      Pay <span className="font-bold text-orange-700">₹{total}</span> using any UPI app (GPay, PhonePe, Paytm, BHIM) — scan the QR or send to the UPI ID below.
    </p>
    <div className="flex flex-col sm:flex-row gap-4 items-center">
      <img src={payment.qr_url} alt="UPI QR" className="w-40 h-40 bg-white p-2 rounded border" data-testid="upi-qr-img" />
      <div className="flex-1 w-full space-y-2">
        <CopyField label="UPI ID" value={payment.upi_id} testid="copy-upi-id" />
        <CopyField label="Name" value={payment.upi_name} testid="copy-upi-name" />
        <p className="text-xs text-gray-500 mt-2">After paying, enter the UPI transaction ID below.</p>
      </div>
    </div>
  </div>
);

export const BankBlock = ({ payment, total }) => (
  <div className="border border-orange-200 rounded-lg p-4 bg-gradient-to-br from-orange-50 to-yellow-50" data-testid="bank-block">
    <p className="text-sm text-gray-700 mb-3">
      Transfer <span className="font-bold text-orange-700">₹{total}</span> to the account below via NEFT/IMPS/RTGS:
    </p>
    <div className="space-y-2">
      <CopyField label="Bank" value={payment.bank_name} testid="copy-bank-name" />
      <CopyField label="Beneficiary" value={payment.beneficiary} testid="copy-bank-beneficiary" />
      <CopyField label="Account No" value={payment.account_number} testid="copy-bank-account" />
      <CopyField label="Type" value={payment.account_type} testid="copy-bank-type" />
      <CopyField label="IFSC" value={payment.ifsc} testid="copy-bank-ifsc" />
    </div>
    <p className="text-xs text-gray-500 mt-3">After transfer, enter the UTR / transaction reference number below.</p>
  </div>
);
